import React, { useEffect } from "react";
import { SelectProductForm } from "./SelectProductForm";
import { SelectProductButtons } from "./SelectProductButtons";
import { useFormik } from "formik";
import { validationTemplatesForm } from "./templates/templateValidation";
import { useForm } from "../../../../../shared/utils/forms/useForm";
import { useValidationProduct } from "./templates/validations/useValidationProduct";
import { useLanguageForShared } from "../../../../../shared/utils/languages/useLanguageForShared";
import http from "../../../../utils/http";
import { useSelector } from "react-redux";
import { selectSelectedCustomer } from "../../../../../redux/customer/customerSlice";


export function SelectProductFullForm({
                                        product,
                                        changeQuantityProduct,
                                        changeRouteProducts,
                                        addToCart,
                                        createOrder,
                                        isInCart,
                                        isPharmacy
                                      }) {
  /*  const formik = useFormik({
      initialValues: product?.detail || {},
      validationSchema: validationTemplatesForm[product?.template],
      onSubmit: (values) => {
      }
    });
    const isValid = (callback) => {
      const valid = validationTemplatesForm[product?.template].isValidSync(
        formik.values
      );
      formik.submitForm();
      if (valid) {
        callback && callback();
      }
    };
   */
  const { t } = useLanguageForShared();
  const customer = useSelector(selectSelectedCustomer);
  useEffect(() => {
    setData(product?.detail || {});
  }, [product?.detail]);


  const submitHandler = (event, data) => {
  };

  const {
    dataForm, dataFormatted,
    changeValue,
    errors,
    setData,
    setValidations,
    isSubmit,
    isValid,
    submitAction
  } = useForm(submitHandler);//TODO MAX  aggiungere validation

  const { validations } = useValidationProduct(product?.template, t, dataForm);

  // Call synchronously so validations are always current when isValid() is invoked
  setValidations(validations);

  useEffect(() => {
    setValidations(validations);
  }, [validations]);


  const addToCartHandler = () => {
    const callback = () => {
      addToCart(dataFormatted);//TODO MAX  controllare prima era formik.value
    };
    if (isValid()) {
      callback();
    } else {
      submitAction();
    }
    //isValid(callback);
  };
  const createOrderHandler = () => {
    const callback = (documentUuid) => {
      if (documentUuid) {
        dataFormatted.documentUuid = documentUuid;
      }
      delete dataFormatted.file;
      createOrder(dataFormatted);
    };
    if (isValid()) {
      // enableDocumentUpload (Philips): carica il file su /v2/customer/{id}/documents prima di creare l'ordine
      if (process.env.REACT_APP_ENABLE_DOCUMENT_UPLOAD === "true") {
        const { file, description } = dataForm;
        if (file && customer) {
          http.post(`${process.env.REACT_APP_URL_V2}customer/${customer.id}/documents`, {
            base64: file.base64,
            name: file.name || file.file.name,
            type: file.FileType,
            description: description || undefined
          }).then(result => {
            callback(result);
          });
        } else {
          callback();
        }
      } else {
        callback();
      }
    } else {
      submitAction();
    }
  };

  console.log("dataform", dataForm);
  return (
    <>
      <SelectProductForm
        product={product}
        changeQuantityProduct={changeQuantityProduct}
        dataForm={dataForm}
        setData={setData}
        changeValue={changeValue}
        isSubmit={isSubmit}
        errors={errors}
      />
      <SelectProductButtons
        changeRouteProducts={changeRouteProducts}
        addToCart={addToCartHandler}
        createOrder={createOrderHandler}
        isInCart={isInCart}
        isPharmacy={isPharmacy}
      />
    </>
  );
}
